import Vue from "vue";
import VueI18n from "vue-i18n";
import zh from "view-design/dist/locale/zh-CN";
import en from "view-design/dist/locale/en-US";
import cn from "../language/zh-CN";
import us from "../language/en-US";
const messages = {
    "zh-CN": Object.assign(cn, zh),
    "en-US": Object.assign(us, en),
};
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: sessionStorage.getItem("language") || "zh-CN",
    messages,
    silentTranslationWarn: true,
});
export default i18n;
